import React, { Component } from 'react';
import { Table, Select, Button, message, Input, Checkbox, Radio, Spin } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import QRCode from 'qrcode.react';

import { getToken, deleteToken, addToken, getVerificationCode, updateToken } from '../../common/fetch';
import ContactUs from '../../components/ContactUs';
import UpgradeModal from '../../components/UpgradeModal';
import NewToken from '../NewToken';
import RevokeKeyModal from './RevokeKeyModal';
import { GENERAL_KEY_TABLE, MASTER_KEY_TABLE, MASTER_KEY_TABLE_SMALL } from '../../config/media';
import { APIkeyWrapper } from './style';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import EditableTagGroup from './TagSelector';

const CheckboxGroup = Checkbox.Group;

export const MONTH_NAMES = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec'
];

export const returnDate = (data) => {
	if (!data) return null;
	const d = new Date(data);
	const year = d.getFullYear();
	const month = d.getMonth();
	const date = d.getDate();

	return `${MONTH_NAMES[month]} ${date}, ${year}`;
};

export const GET_TABLE_TOKEN_COLUMN = (revokeToken = () => { }, handleOpenKeyDetails = () => { }, expandedRowKeys) => [
	{
		title: 'Name',
		width: '16%',
		render: (text, data) => {
			if (!expandedRowKeys.includes(`${data.id}`)) {
				return <div className='name-section' onClick={() => handleOpenKeyDetails(data)}>
					<div className='highlight-txt'>{data.type === 'main' ? 'Main key' : data.name}</div>
					<CaretUpOutlined />
				</div>
			} else {
				return <div className='name-section' onClick={() => handleOpenKeyDetails(data)}>
					<div className='highlight-txt'>{data.type === 'main' ? 'Main key' : data.name}</div>
					<CaretDownOutlined />
				</div>
			}
		}
	},
	{
		title: 'Type',
		dataIndex: 'type',
		width: '16%',
		render: (val) => (
			<div>
				{val === 'main'
					?
					<div className='name-section'>
						<img src={MASTER_KEY_TABLE_SMALL} className="master-key-icon" alt="master-key" />
						<div className='highlight-txt'>Main</div>
					</div>
					:
					<div className='name-section'>
						<div className='highlight-txt'>Standard</div>
					</div>
				}
			</div>
		)
	},
	{
		title: 'Date Generated',
		dataIndex: 'created',
		width: '16%',
		render: (d) => returnDate(d)
	},
	{
		title: 'Expiry date',
		dataIndex: 'expiry',
		width: '16%',
		render: (d) => returnDate(d)
	},
	{
		title: 'Revoke',
		dataIndex: 'revoked',
		width: '10%',
		render: (bool, row, index) => {
			if (!bool) {
				if (row.active) {
					return <Link onClick={(e) => { e.stopPropagation(); revokeToken(row, true) }}>Revoke</Link>;
				}
				return <span className='disabled'>Inactive</span>;
			} else {
				return <span className='disabled'>Revoked</span>;
			}
		}
	}
];

class APIKey extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			selectedItem: 'active',
			isOpenNewToken: false,
			visible: false,
			loading: false,
			isUpgrade: false,
			newTokenLoading: false,
			newToken: {},
			params: { active: true },
			isRevoke: false,
			revokedData: {},
			step: 1,
			checkedList: [],
			ipType: '',
			advancedAccess: false,
			whitelistedIPs: [],
			isSaveApiKey: false,
			currentApiData: {},
			isShowQRCode: false,
			isAdvancedAccess: [],
			isAccessChange: false,
			isError: false,
			isOpen2fa: false,
			expandedRowKeys: [],
		};
	}

	componentDidMount() {
		this.getToken(this.state.params);
	}

	handleRevoke = (data) => {
		const { revokedData } = this.state;
		this.revokeToken({ ...data, token_id: revokedData.id });
	};

	handleOk = (body) => {
		message.success(body);
		this.handleCancel();
	};

	handleError = (body) => {
		message.error(body);
		this.handleCancel();
	};

	handleCancel = () => {
		this.setState({ visible: false });
	};

	handleClick = async (e, record) => {
		if (e.target.className.indexOf('active') >= 0) {
			this.setState({ visible: true });
		}
	};

	handleSelect = (v) => {
		let params = {};
		if (v === 'active') {
			params.active = true;
		}
		if (v === 'revoked') {
			params.active = false;
		}
		if (v === 'inactive') {
			params.active = false;
		}
		this.getToken(params);
		this.setState({ selectedItem: v, params });
	};

	getVerificationCode = async () => {
		try {
			await getVerificationCode();
		} catch (error) {
			console.error(error);
		}
	};

	getToken = async (params = {}, isShowKeyDetails = false) => {
		this.setState({ loading: true });
		try {
			const res = await getToken(params);
			if (res && res.data && res.data.data) {
				let data = res.data.data.reverse();
				const mainToken = data.filter(item => item.type === 'main');
				const standardToken = data.filter(item => item.type === 'standard');
				data = [
					...mainToken,
					...standardToken
				]
				if (!isShowKeyDetails) {
					this.setState({ loading: false, data });
				} else {
					this.setState({ data });
					setTimeout(() => {
						this.setState({ loading: false });
					}, 2000);
				}
			}
		} catch (error) {
			message.error(error.data.message);
			this.setState({ loading: false });
		}
	};

	revokeToken = async (body) => {
		try {
			const res = await deleteToken(body);
			this.setState(
				{
					data: this.state.data.filter((item) => item.id !== body.token_id)
				},
				this.props.history.goBack
			);
			this.closeRevokeKey();
			let successMsg = res.data && res.data.message;
			message.success(successMsg);
		} catch (error) {
			let _error = error.data && error.data.message
				? error.data.message
				: error.message;
			message.error(_error);
			this.closeRevokeKey();
		}
	};

	addNewToken = async (body, callback = () => { }) => {
		this.setState({ newTokenLoading: true });
		try {
			const res = await addToken(body);
			callback();
			this.setState({
				newToken: res.data,
				newTokenLoading: false,
				isOpenNewToken: false,
				isShowQRCode: true
			});
			this.getToken({}, true);
			setTimeout(() => {
				let currentSelectedData = {};
				this.state.data.forEach(elem => {
					if (elem.apiKey === this.state.newToken.apiKey) {
						currentSelectedData = elem;
					}
				});
				this.handleOpenKeyDetails(currentSelectedData);
			}, 2000);
		} catch (error) {
			this.setState({ newTokenLoading: false, isOpenNewToken: false, isShowQRCode: false });
			if (error.data && error.data.message) {
				message.error(error.data.message);
			}
		}
	};

	createToken = () => {
		// if (this.state.data.filter((val) => val.active).length < 1) {
		// 	this.addNewToken();
		// }
		this.setState({ isOpenNewToken: true });
	};

	closeModal = () => {
		this.setState({ isUpgrade: false });
	};

	handleCloseNewToken = () => {
		this.setState({ isOpenNewToken: false });
		this.getToken(this.state.params);
	};

	handleRevokeKey = (revokedData, isRevoke) => {
		this.setState({ isRevoke, revokedData })
	}

	closeRevokeKey = () => {
		this.setState({ isRevoke: false, step: 1 });
	};

	handleStep = (step) => {
		this.setState({ step });
	};

	handleOpenKeyDetails = (data) => {
		let currentKeys = [...this.state.expandedRowKeys];
		let currentApiData = { ...data };
		let checkedList = [];
		let advancedAccess = false;
		let whitelistedIPs = [];
		let ipType = '';
		if (currentKeys.includes(`${data.id}`)) {
			currentKeys = currentKeys.filter(key => key !== `${data.id}`);
			currentApiData = {};
		} else {
			currentKeys = [`${data.id}`];
			if (data.can_read) checkedList.push('Reading (wallets balances, etc)');
			if (data.can_trade) checkedList.push('Trading');
			if (data.can_withdraw) {
				advancedAccess = true;
			};
			if (data.white_listed_ips) {
				whitelistedIPs = data.white_listed_ips;
			}
			if (data.white_listed_ips.length) {
				ipType = 'onlyTrustedIp';
			} else {
				ipType = 'anyIp';
			};
		}
		this.setState({
			expandedRowKeys: currentKeys,
			currentApiData,
			checkedList,
			ipType,
			advancedAccess,
			whitelistedIPs,
			isSaveApiKey: false,
			isAdvancedAccess: [],
			isAccessChange: false,
			isError: false,
			isOpen2fa: false,
		});
	};

	copy = (e) => {
		const copyText = e.input;
		/* Select the text field */
		copyText.select();
		copyText.setSelectionRange(0, 99999); /*For mobile devices*/

		/* Copy the text inside the text field */
		document.execCommand('copy');
		message.success('Copied!');
	};

	onAccessChange = (type, value) => {
		this.setState({ isAccessChange: true });
		if (type === 'basicAccess') {
			this.setState({ checkedList: value });
		}

		if (type === 'ipAccess' && value === 'anyIp') {
			this.setState({ ipType: value, whitelistedIPs: [] });
		} else if (type === 'ipAccess') {
			this.setState({ ipType: value });
		}
		if (type === 'advancedAccess') {
			this.setState({ advancedAccess: value, isAdvancedAccess: [value] });
		}
	};

	handleTag = (value) => {
		if (value.length) {
			this.setState({ whitelistedIPs: value, isError: false, isAccessChange: true });
		} else {
			this.setState({ whitelistedIPs: value, isError: true, isAccessChange: false });
		}
	};

	handleSaveApiKey = () => {
		const { ipType, whitelistedIPs } = this.state;
		const { user } = this.props;
		if (user && !user.otp_enabled) {
			this.setState({ isOpen2fa: !this.state.isOpen2fa, isError: false });
		} else if ((ipType === 'onlyTrustedIp' && !whitelistedIPs.length)) {
			this.setState({ isError: true, isAccessChange: false });
		} else {
			this.setState({ isSaveApiKey: !this.state.isSaveApiKey, isError: false });
		}
	};

	getBasicDefaultValue = (record, basicAccessOptions) => {
		let options = [];
		if (record.can_trade && record.can_read) {
			options.push(...basicAccessOptions);
		} else if (!record.can_read && record.can_trade) {
			options.push(basicAccessOptions[1]);
		} else if (record.can_read && !record.can_trade) {
			options.push(basicAccessOptions[0]);
		}
		return options;
	};

	renderKeyDetails = (record, key) => {
		const {
			ipType = '',
			advancedAccess,
			whitelistedIPs,
			isShowQRCode,
			newToken,
			isAccessChange,
			isError,
			expandedRowKeys
		} = this.state;
		const basicAccessOptions = ['Reading (wallets balances, etc)', 'Trading'];
		if (!expandedRowKeys.includes(`${record.id}`)) {
			return (<div></div>);
		}
		return <div className='details-wrapper' key={key}>
			{isShowQRCode && newToken.apiKey === record.apiKey
				? <QRCode
					value={JSON.stringify({ key: record.apiKey, secret: record.secret })}
					size={150}
				/>
				: (record.type === 'main'
					? <img src={MASTER_KEY_TABLE} className="key-icon" alt="master-key" />
					: <img src={GENERAL_KEY_TABLE} className="key-icon" alt="master-key" />
				)
			}
			<div className='section-wrapper'>
				<div className='section-1'>
					<div className='apiKey-wrapper'>
						{record.type === 'main'
							? <div className='header-txt'><b>API Key (Main)</b></div>
							: <div className='header-txt'><b>API Key (Standard)</b></div>
						}
						<Input
							ref={(el) => {
								this.apiKey = el;
							}}
							value={record.apiKey}
							readOnly
							addonAfter={
								<div
									onClick={() => this.copy(this.apiKey)}
								>
									COPY
								</div>
							}
							className="api-key"
						/>
					</div>
					<div className='secretKey-wrapper'>
						<div className='header-txt'><b>Secret Key</b></div>
						<Input
							ref={(el) => {
								this.secret = el;
							}}
							value={isShowQRCode && newToken.apiKey === record.apiKey ? newToken.secret : record.secret}
							readOnly
							addonAfter={
								<div
									onClick={() => this.copy(this.secret)}
								>
									COPY
								</div>
							}
							className="api-key"
						/>
					</div>
				</div>
				<div className='header-txt mt-1'><b>Access</b></div>
				<div className='access-wrapper'>
					<div className='w-30'>
						<div>
							<div>
								<div className='header-txt small-txt'>Basic access</div>
								<div className='small-txt-info'>Select what this API key can access.</div>
								<CheckboxGroup options={basicAccessOptions} defaultValue={this.getBasicDefaultValue(record, basicAccessOptions)} onChange={(val) => this.onAccessChange('basicAccess', val)} />
							</div>
						</div>
					</div>
					<div className='w-30'>
						<div>
							<div className='header-txt small-txt'>IP access</div>
							<div className='small-txt-info'>Configure what IP address will work with this API key.</div>
							<Radio.Group
								name="ipAccess"
								onChange={(e) => this.onAccessChange('ipAccess', e.target.value)}
								defaultValue={ipType}
							>
								<Radio value="anyIp">
									<span className="radio-text">Any IP address</span>
								</Radio>
								<Radio value="onlyTrustedIp" className='onlyTrustedIp'>
									<span className="radio-text">Only trusted IPs</span>
								</Radio>
								{ipType === 'onlyTrustedIp' && record.white_listed_ips.length
									?
									<div className='ipInput-wrapper'>
										<EditableTagGroup
											tags={record.white_listed_ips}
											handleTag={this.handleTag}
											isError={isError}
										/>
									</div>
									: (ipType === 'onlyTrustedIp'
										? <div className='ipInput-wrapper'>
											<EditableTagGroup
												tags={[]}
												handleTag={this.handleTag}
												isError={isError}
											/>
										</div>
										: null
									)
								}
							</Radio.Group>
						</div>
					</div>
					<div className={(ipType === 'onlyTrustedIp' && (record.white_listed_ips.length || whitelistedIPs.length)) || record.type === 'main' ? 'w-30' : 'disable w-30'}>
						<div>
							<div className='header-txt small-txt'>Advanced access</div>
							{record.type === 'main'
								? <div className='small-txt-info'>Provides sensitive access to financial features such as withdrawal etc.</div>
								: <div className='small-txt-info'>Requires trusted IPs be activated.</div>
							}
							<Checkbox
								name="withdraw"
								onChange={(e) => this.onAccessChange('advancedAccess', e.target.checked)}
								defaultChecked={record.can_withdraw}
								checked={advancedAccess}
							>
								<span className={advancedAccess ? 'active' : ''}>{record.type === 'main' ? 'Financials' : 'Withdrawals'}</span>
							</Checkbox>
						</div>
					</div>
				</div>
				<Button
					type='primary'
					onClick={this.handleSaveApiKey}
					disabled={!isAccessChange}
				>
					SAVE
				</Button>
			</div>
		</div>
	}

	handleGetAuth = async (data) => {
		const { checkedList, advancedAccess, whitelistedIPs, currentApiData, isAdvancedAccess, ipType } = this.state;
		const body = {
			...data,
			can_read: checkedList.includes('Reading (wallets balances, etc)') ? true : false,
			can_trade: checkedList.includes('Trading') ? true : false,
			can_withdraw: isAdvancedAccess.length ? (advancedAccess ? true : false) : currentApiData.can_withdraw,
			white_listed_ips: whitelistedIPs.length && ipType === 'onlyTrustedIp' ? whitelistedIPs : [],
			token_id: currentApiData && currentApiData.id
		}
		try {
			await updateToken(body);
			this.handleSaveApiKey();
			this.getToken();
			this.setState({ isAccessChange: false });
			message.success('Token updated successfully');
		} catch (error) {
			let _error = error.data && error.data.message
				? error.data.message
				: error.message;
			message.error(_error);
			this.handleSaveApiKey();
			this.setState({ isAccessChange: false });
		}
	};

	render() {
		const {
			visible,
			isUpgrade,
			isOpenNewToken,
			selectedItem,
			loading,
			data,
			newToken,
			newTokenLoading,
			isRevoke,
			revokedData,
			step,
			isSaveApiKey,
			isOpen2fa,
			expandedRowKeys
		} = this.state;
		const { user, history } = this.props;
		const isMainKeyExist = !!data.filter(item => item.type === 'main').length;
		return (
			<APIkeyWrapper>
				<div className='main-header'>Exchange Keys</div>
				<div className='content'>
					<div className='inner-content'>
						<div className='header'>Exchange network keys</div>
						<div>
							Your exchange network keys are used to install your
							exchange. Your unique key should not be shared with
							anyone and should be stored securely. Main key is used as your main exchange key while
							Standard key is for other development and API usage.
						</div>
					</div>
					<div>
						<div className='d-flex content-align'>
							<div>
								<Select value={selectedItem} onChange={this.handleSelect}>
									<Select.Option value=''>All</Select.Option>
									<Select.Option value='active'>Active</Select.Option>
									<Select.Option value='inactive'>Inactive</Select.Option>
									<Select.Option value='revoked'>Revoked</Select.Option>
								</Select>
							</div>
							<div className='d-flex btn-align'>
								<Button type='primary' onClick={this.createToken}>
									Generate
								</Button>
							</div>
						</div>
						<div className='table-align table-wrapper'>
							<Spin spinning={loading} className='center-spin'>
							<Table
								columns={GET_TABLE_TOKEN_COLUMN(this.handleRevokeKey, this.handleOpenKeyDetails, expandedRowKeys)}
								rowKey={(data) => `${data.id}`}
								dataSource={data}
								pagination={false}
								expandedRowKeys={this.state.expandedRowKeys}
								// onRow={(record) => {
								// 	return {
								// 		onClick: (e) => {
								// 			this.handleClick(e, record);
								// 		}
								// 	};
								// }}
								expandedRowRender={(record, index) => this.renderKeyDetails(record, index)}
								expandRowByClick={false}
								expandIconAsCell={false}
								expandIconColumnIndex={-1}
							/>
							</Spin>
						</div>
					</div>
				</div>

				<ContactUs
					visible={visible}
					defaultType='API Keys'
					handleOk={this.handleOk}
					handleError={this.handleError}
					handleCancel={this.handleCancel}
				/>
				<UpgradeModal
					visible={isUpgrade}
					step={1}
					handleError={this.closeModal}
					handleCancel={this.closeModal}
					handleOk={this.closeModal}
				/>
				{isOpenNewToken && (
					<NewToken
						visible={isOpenNewToken}
						newToken={newToken}
						isLoading={newTokenLoading}
						isActiveToken={!!data.filter(val => val.active).length}
						onOk={this.handleCloseNewToken}
						onCancel={this.handleCloseNewToken}
						addNewToken={this.addNewToken}
						handleClose={() => {
							this.setState({ isOpenNewToken: false });
						}}
						getVerificationCode={this.getVerificationCode}
						user={user}
						history={history}
						isMainKeyExist={isMainKeyExist}
					/>
				)}
				{isRevoke
					? <RevokeKeyModal
						visible={isRevoke}
						revokedData={revokedData}
						step={step}
						handleStep={this.handleStep}
						onOk={this.handleRevoke}
						onCancel={this.closeRevokeKey}
						getVerificationCode={this.getVerificationCode}
					/>
					: null
				}
				{isSaveApiKey && (
					<NewToken
						visible={isSaveApiKey}
						onOk={this.handleSaveApiKey}
						onCancel={this.handleSaveApiKey}
						handleClose={() => {
							this.setState({ isSaveApiKey: false });
						}}
						isSaveApiKey={isSaveApiKey}
						handleGetAuth={this.handleGetAuth}
						getVerificationCode={this.getVerificationCode}
						isMainKeyExist={isMainKeyExist}
					/>
				)}
				{isOpen2fa && (
					<NewToken
						visible={isOpen2fa}
						onOk={this.handleSaveApiKey}
						onCancel={this.handleSaveApiKey}
						handleClose={() => {
							this.setState({ isOpen2fa: false });
						}}
						isOpen2fa={isOpen2fa}
						history={history}
					/>
				)}
			</APIkeyWrapper>
		);
	}
}

const mapStateToProps = (state) => ({
	exchange: state.exchange && state.exchange.length ? state.exchange[0] : {},
	user: state.user
});

export default connect(mapStateToProps)(APIKey);
